// src/features/monitoring/MonitoringWorkspacePage.tsx
import { LoadingBoundary, PageContainer } from '../../app/components/foundation';
import { MonitoringHeader, MonitoringLiveSnapshot } from './components';
import { useMonitoring } from './hooks/useMonitoring';
import './styles/monitoring.css';

/**
 * Monitoring Workspace Foundation (/monitoring/:id). Same shell
 * pattern as AuditWorkspacePage/CommissionWorkspacePage:
 * PageContainer + feature-owned header, card grid below, RTL/Persian
 * throughout, existing tokens/primitives only.
 *
 * Reads `id` from the route params and resolves everything through
 * useMonitoringWorkspaceMock(id) — the monitoring record plus its
 * service/health/metrics/errors/timeline, all still mock data from
 * data/monitoring.mock.ts. No API calls; useMonitoringWorkspaceMock
 * is the seam a later phase swaps for a real monitoring-detail hook
 * without touching this file or the cards below it (same shape).
 */
export function MonitoringWorkspacePage() {
  const { monitoring, loading, error } = useMonitoring();

  return (
    <PageContainer className="flex flex-col gap-6">
      <MonitoringHeader />
      <LoadingBoundary loading={loading} error={error}>
        {monitoring ? <MonitoringLiveSnapshot monitoring={monitoring} /> : null}
      </LoadingBoundary>
    </PageContainer>
  );
}
